export const API_BASE_URL = 'https://skateiq.onrender.com';